export const tool = {
  name: 'randomize',
  description: 'A tool that randomizes aspects of the 3D model, such as shape, material, or both.',
  type: 'function',
  parameters: {
    type: 'object',
    properties: {
      target: {
        type: 'string',
        enum: ['shape', 'material', 'both'],
        default: 'shape',
        description: 'Specifies what to randomize. Defaults to shape.',
      },
      message: {
        type: 'string',
        default: 'Randomize model features',
      },
    },
    required: ['message'],
  },
};
